import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <RankingSection />
        <CardsSection />
        <IndexSection />
        <UpdatesSection />
        <FeaturesSection />
        <ContactSection />
        <AppSection />
        <CommentsSection />
        <FaqSection />
        <MediaSection />
        <CarouselSection />
        <AboutSection />
      </main>
      <Footer />
    </div>
  );
}